module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/files/files.component.html
// module id = ./src/app/files/files.component.html
// module chunks = main